import type { User } from '@/shared/apiTypes';

/** The permission each top-level workspace view requires (the navigation shows exactly these). */
export const WORKSPACE_VIEW_PERMISSIONS: Readonly<Record<string, string>> = {
  dashboard: 'dashboard.access',
  kanban: 'kanban.access',
  gantt: 'gantt.access',
  calendar: 'calendar.access',
  docs: 'docs.access',
  reports: 'reports.access',
  settings: 'settings.access',
};

export type WorkspacePermissionCheck = (resource: string, action: string) => boolean;

export const canOpenWorkspaceView = (view: string, hasPermission: WorkspacePermissionCheck): boolean => {
  const permission = WORKSPACE_VIEW_PERMISSIONS[view];
  if (!permission) return true;
  const [resource, action] = permission.split('.');
  return hasPermission(resource, action);
};

/**
 * False for a signed-in account that may open no workspace view: the app shows only
 * "Workspace setup needed", so nothing renders project data or needs realtime updates.
 */
export const hasAnyWorkspaceView = (user: User | null, hasPermission: WorkspacePermissionCheck): boolean =>
  Boolean(user) && Object.keys(WORKSPACE_VIEW_PERMISSIONS).some((view) => canOpenWorkspaceView(view, hasPermission));
